import type { Individual } from 'api/btlApplicationForm/types';

export function mapIndividualToFormValues(individual?: Individual): Record<string, unknown> {
  if (!individual) {
    return {};
  }

  const {
    addressHistory: addressList = [],
    contactDetails,
    previousTitle,
    previousFirstName,
    previousMiddleName,
    previousLastName,
    expectedGrossIncome: grossIncome,
    ...rest
  } = individual;

  const transformedAddressList = addressList.map(address => {
    address.address['isManual'] = true;
    return address;
  });

  return {
    ...rest,
    addressList: [...transformedAddressList],
    previousNames: previousFirstName
      ? [
          {
            title: previousTitle,
            firstName: previousFirstName,
            middleName: previousMiddleName,
            lastName: previousLastName,
          },
        ]
      : [],
    email: contactDetails?.find(contact => contact.contactType === 'EMAIL')?.contact,
    phoneNumber: contactDetails?.find(contact => contact.contactType === 'PHONE')?.contact,
    grossIncome,
  };
}
